export const injectTracker = () => {
    return '/api/huizhuyun-analysis/collect/regular/inject'
  }